import { render, staticRenderFns } from "./DrawManage.vue?vue&type=template&id=35056930&scoped=true&"
import script from "./DrawManage.vue?vue&type=script&lang=js&"
export * from "./DrawManage.vue?vue&type=script&lang=js&"
import style0 from "./DrawManage.vue?vue&type=style&index=0&id=35056930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35056930",
  null
  
)

export default component.exports